import React, { FunctionComponent, SVGProps } from 'react';
import { ColorScheme, ILogoColorSchemeProps } from 'app/components/svgs/logos/constants';

const SvgBellbirdLogo: FunctionComponent<SVGProps<SVGSVGElement> & ILogoColorSchemeProps> = ({
  colorScheme = ColorScheme.Dark,
  ...svgProps
}) => (
  <svg viewBox="0 0 1077 232" fill="none" {...svgProps}>
    <path
      d="M857.9 84.17l14.15-40.52 20.88 10.11c13.94-7.12 29.89-11.05 46.79-10.74
         18.05.32 34.88 5.46 49.2 14.1l21.2-8.42 10.72 39.7c9.25 14.8 14.47 32.25 14.15
         50.85-.96 52.2-45.15 93.72-98.72 92.73-53.54-.95-96.22-44.03-95.25-96.22.33-19.19
         6.54-36.88 16.88-51.59"
      fill="#FF7300"
    />
    <path
      d="M913 139.77s24.48-8.48 55 0c0 0-8.94 17.67-28.29 30.23 0 0-18.22-11.82-26.71-30.23z"
      fill="#FFFFFE"
    />
    <path
      d="M926 125.5c0 15.74-12.76 28.5-28.5 28.5S869 141.24 869 125.5 881.76 97 897.5 97s28.5
         12.76 28.5 28.5zm86 0c0 15.74-12.76 28.5-28.5 28.5S955 141.24 955 125.5 967.76 97 983.5
         97s28.5 12.76 28.5 28.5z"
      fill="#FFFFFE"
    />
    <path
      d="M983 117.34a8.54 8.54 0 0 0 8.37 8.66 8.52 8.52 0 0 0
         8.63-8.37c.1-4.68-3.66-8.56-8.34-8.63a8.53 8.53 0 0 0-8.66
         8.34zm-85 1.03a8.47 8.47 0 0 0 8.35 8.63c4.7.1 8.57-3.65
         8.65-8.35a8.5 8.5 0 0 0-5.1-7.95 8.49 8.49 0 0 0-9.3 1.69
         8.51 8.51 0 0 0-2.6 5.98M843.6 142l-6.9-.2c-19.72-.65-35.34-17.35-34.67-37.03.67-19.77
         17.33-35.42 37.07-34.75l6.9.2-2.4 71.78z"
      fill="#404040"
    />
    <path
      d="M835 140.76l2.27-70.29c.19-5.35 4.7-9.66 9.98-9.46l1.42.1c5.27.18
         9.51 4.77 9.32 10.13l-2.26 70.29c-.19 5.35-4.7 9.66-9.98
         9.46l-1.42-.1c-5.37-.18-9.51-4.68-9.32-10.13H835zM1035.4
         142l6.9-.2c19.73-.66 35.35-17.36 34.68-37.04-.67-19.77-17.34-35.41-37.08-34.74l-6.9.2 2.4 71.78z"
      fill="#404040"
    />
    <path
      d="M1044 140.76l-2.37-70.29c-.2-5.35-4.91-9.66-10.42-9.46l-1.47.1c-5.5.18-9.93
         4.77-9.73 10.13l2.36 70.29c.2 5.35 4.91 9.66 10.42 9.46l1.47-.1c5.5-.18 9.93-4.68 9.73-10.13h.01z"
      fill="#404040"
    />
    <path
      d="M1033 80.3c-2.1 0-4.11-1.35-4.78-3.46-13.32-39.07-49.24-65.34-89.2-65.34-40.04
         0-75.86 26.27-89.18 65.34-.86 2.69-3.83 4.04-6.42 3.17-2.68-.86-4.02-3.85-3.16-6.45
         14.66-43.2 54.32-72.26 98.67-72.26 44.36 0 84.02 29.06 98.77 72.26.23.63.33 1.3.29
         1.97a5 5 0 0 1-1.71 3.5 5 5 0 0 1-1.74.98c-.48.2-1.05.29-1.53.29h-.01zm-62.05 125c-2.79
         0-5.57-.1-8.16-.38-1.63-.1-2.88-1.92-2.78-4.03.1-2.1 1.53-3.73 3.16-3.54 24.67
         2.1 43.86-5.37 55.57-21.46 8.83-12.17 10.36-25.1 10.36-25.3.29-2.1 1.73-3.54 3.36-3.25
         1.63.28 2.78 2.2 2.5 4.3-.1.58-1.73 15.15-11.71 29.04-14.01 19.64-34.93 24.62-52.3 24.62z"
      fill="#404040"
    />
    <path
      d="M964.16 209.3h-8.32c-4.31 0-7.84-3.38-7.84-7.5 0-4.13 3.53-7.5 7.84-7.5h8.32c4.31
         0 7.84 3.38 7.84 7.5 0 4.13-3.53 7.5-7.84 7.5z"
      fill="#404040"
    />
    <path
      d="M15.08 56.78h33.9c15.73 0 27.09 2.3 34.07 6.88 7.03 4.58 10.54 11.82 10.54
         21.72 0 6.66-1.72 12.2-5.15 16.64-3.44 4.42-8.39 7.2-14.85 8.36v.78c8.02 1.5 13.91
         4.5 17.66 8.98 3.8 4.43 5.7 10.44 5.7 18.05 0 10.26-3.6 18.3-10.78 24.14C79.04
         168.1 69.1 171 56.33 171H15.08V56.78zm18.67 47.19h17.97c7.81 0 13.51-1.22 17.1-3.67
         3.6-2.5 5.4-6.72 5.4-12.66 0-5.36-1.95-9.24-5.86-11.64-3.85-2.4-10-3.6-18.44-3.6H33.75v31.57zm0
         15.16v36.17h19.84c7.82 0 13.7-1.49 17.66-4.46 4.01-3.02 6.02-7.76 6.02-14.22
         0-5.93-2.04-10.33-6.1-13.2-4.06-2.86-10.23-4.3-18.51-4.3H33.75zM185.31
         171h-64.6V56.78h64.6v15.78h-45.94v31.1h43.05v15.62h-43.04v35.86h45.93V171zm24.77
         0V56.78h18.67v98.2h48.36V171h-67.03zm86.72 0V56.78h18.67v98.2h48.36V171H296.8zm86.72-114.22h33.9c15.73
         0 27.08 2.3 34.06 6.88 7.04 4.58 10.55 11.82 10.55 21.72 0 6.66-1.72 12.2-5.15
         16.64-3.44 4.42-8.39 7.2-14.85 8.36v.78c8.02 1.5 13.9 4.5 17.66 8.98 3.8 4.43 5.7
         10.44 5.7 18.05 0 10.26-3.6 18.3-10.78 24.14-7.14 5.78-17.08 8.67-29.84
         8.67h-41.25V56.78zm18.67 47.19h17.97c7.8 0 13.51-1.22 17.1-3.67 3.6-2.5 5.4-6.72 5.4-12.66
         0-5.36-1.96-9.24-5.86-11.64-3.86-2.4-10-3.6-18.44-3.6h-16.17v31.57zm0 15.16v36.17h19.84c7.81
         0 13.7-1.49 17.66-4.46 4-3.02 6.01-7.76 6.01-14.22
         0-5.93-2.03-10.33-6.1-13.2-4.05-2.86-10.23-4.3-18.5-4.3h-18.91zM489.14
         171V56.78h18.67V171h-18.67zm67.58-61.1h12.97c8.7 0 15-1.6 18.9-4.84 3.91-3.23
         5.86-8.02 5.86-14.37 0-6.46-2.1-11.1-6.33-13.9-4.21-2.82-10.57-4.23-19.06-4.23h-12.34v37.35zm0
         15.47V171h-18.67V56.78h32.26c14.74 0 25.65 2.76 32.74 8.28 7.08 5.52 10.62 13.86 10.62
         25 0 14.22-7.4 24.35-22.19 30.4L623.75 171H602.5l-27.34-45.63h-18.44zm176.56-12.57c0
         18.85-5.23 33.28-15.7 43.28-10.47 9.95-25.55 14.92-45.24 14.92H640.4V56.78h35.31c18.18
         0 32.32 4.9 42.42 14.69 10.1 9.79 15.16 23.57 15.16
         41.33zm-19.69.62c0-27.34-12.78-41.01-38.36-41.01h-16.17v82.89h13.28c27.5 0 41.25-13.96 41.25-41.88z"
      fill={colorScheme === ColorScheme.Dark ? '#404040' : '#FFFFFF'}
    />
  </svg>
);

export default SvgBellbirdLogo;
